import React from 'react';
import { SupplierReview } from '@/shared/types/catalog';
import { numberWithCommas } from '@/shared/utils/utils';
import { Pagination, Rate } from 'antd';
import ReviewDetails from './ReviewDetails';
import { SupplierReviewSummaryResponse } from '@/shared/types/api/catalog';
import { useCreateAccountProvider } from '@/lib/context';
import { useQueryParams } from '@/shared/hooks';
import { ParamKey } from '@/shared/types/url-params';
import { convertReviewScoreToScale } from '@/shared/utils/sourcing-marketplace-util';
import './index.less';
import isEmpty from 'lodash/isEmpty';

interface IProps {
  reviewsList: SupplierReview[];
  reviewSummary: SupplierReviewSummaryResponse;
  total: number;
  page: number;
  supplierName: string;
}

const SupplierReviews = ({ reviewsList, reviewSummary, total, page, supplierName }: IProps) => {
  const { setQueryParams } = useQueryParams<{}>();

  const { showSignupDialog } = useCreateAccountProvider();

  const numReviews = reviewSummary?.count || 0;

  const onPageChange = (newPage: number) => {
    setQueryParams({ [ParamKey.PAGE]: newPage });
  };

  return (
    <div className="supplier-reviews">
      <div className="rate-box">
        {numReviews > 0 ? (
          <div className="rating">
            <Rate
              style={{ color: '#ff5c3c' }}
              disabled
              allowHalf
              value={convertReviewScoreToScale(reviewSummary?.score)}
            />
            <span>
              {numberWithCommas(numReviews)} review{numReviews > 1 ? 's ' : ' '}
              for {supplierName}
            </span>
          </div>
        ) : (
          <span className="no-reviews">Be the first to write a review for {supplierName}!</span>
        )}
        <div className="add-review-button" onClick={showSignupDialog}>
          {/* eslint-disable-next-line @next/next/no-img-element */}
          <img src="/images/sourcing/add-icon.svg" width={12} height={12} alt="add" />
          <span>Write a review</span>
        </div>
      </div>

      {!isEmpty(reviewsList) && (
        <>
          <div className="content-box">
            {reviewsList.map((review: SupplierReview, index: number) => (
              <ReviewDetails review={review} key={index} />
            ))}
          </div>
        </>
      )}

      <Pagination
        defaultCurrent={page}
        total={total}
        defaultPageSize={20}
        onChange={onPageChange}
        hideOnSinglePage
        showSizeChanger={false}
      />
    </div>
  );
};

export default SupplierReviews;
